import { render, staticRenderFns } from "./NewPatientsTab.vue?vue&type=template&id=f06f9662&scoped=true"
import script from "./NewPatientsTab.vue?vue&type=script&lang=js"
export * from "./NewPatientsTab.vue?vue&type=script&lang=js"
import style0 from "./NewPatientsTab.vue?vue&type=style&index=0&id=f06f9662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f9662",
  null
  
)

export default component.exports